module.exports = __webpack_public_path__ + "img/g2Testimonials.b7633ef3.webp";